import { toastr } from "react-redux-toastr";
import object from "lodash/object";
import { getAccessToken } from "../../utils/tokens";
import { fetchRequest } from "../../utils/http.ts";
import { logError } from "../../components/Errors";
import { fullAPIURL } from "../../utils/requests";

export const SET_LOCATIONS = "SET_LCATIONS";
export function setLocations(locations) {
  return {
    type: SET_LOCATIONS,
    locations,
  };
}

export const LOCATIONS_ERROR = "LOCATIONS_ERROR";
export function setLocationsError(error) {
  return async function (dispatch, getState) {
    const state = getState();
    const { data: user } = state.user;
    const { data: client } = state.client;
    logError({
      client: object.get(client, "uuid"),
      user: {
        id: object.get(user, "user_uuid"),
        name: `${object.get(user, "first_name")} ${object.get(
          user,
          "last_name",
        )}`,
      },
      message: error,
      severity: "error",
      feature: LOCATIONS_ERROR,
    });
    toastr.warning("Error", "An error occured. Please try again later.");
    return Promise.resolve();
  };
}

export const FETCH_LOCATIONS = "FETCH_LOCATIONS";
export function fetchLocations() {
  return async function (dispatch, getState) {
    const token = getAccessToken();

    const state = getState();
    const { data: client } = state.client;
    const clientUuid = object.get(client, "uuid");

    let response = null;
    try {
      response = await fetchRequest({
        method: "GET",
        path: `${fullAPIURL}/v2/calendar/location?clientId=${clientUuid}`,
        options: {
          token,
        },
      });
    } catch (err) {
      // network error
      return dispatch(setLocationsError(err));
    }

    if (response && response.ok) {
      const text = await response.text();

      try {
        const body = JSON.parse(text);
        const { data } = body;
        return dispatch(setLocations(data));
      } catch (err) {
        return dispatch(setLocationsError(err));
      }
    } else {
      return dispatch(setLocationsError(new Error("Response failed")));
    }
  };
}

export const UPDATE_LOCATION = "UPDATE_LOCATION";
export function updateLocation(location) {
  return async function (dispatch) {
    const { uuid, name, isVirtualLocation, hasLink, linkName, linkUrl } =
      location;
    const token = getAccessToken();
    let response = null;
    try {
      response = await fetchRequest({
        method: "PATCH",
        path: `${fullAPIURL}/v2/calendar/location/${uuid}`,
        body: {
          name,
          isVirtualLocation,
          hasLink,
          linkName,
          linkUrl,
          isActive: true,
        },
        options: {
          token,
          headers: { "Content-Type": "application/json" },
        },
      });
    } catch (err) {
      // network error
      return dispatch(setLocationsError(err));
    }

    if (response && response.ok) {
      toastr.success("Successfully updated location");
      return dispatch(fetchLocations());
    }
    return dispatch(setLocationsError(new Error("Response failed")));
  };
}

export const CREATE_LOCATION = "CREATE_LOCATION";
export function createLocation(location = {}) {
  return async function (dispatch) {
    const { name, isVirtualLocation, linkName, linkUrl } = location;
    const token = getAccessToken();
    let response = null;
    try {
      response = await fetchRequest({
        method: "POST",
        path: `${fullAPIURL}/v2/calendar/location`,
        body: {
          name,
          isVirtualLocation,
          hasLink: !!linkName && !!linkUrl,
          linkName,
          linkUrl,
          isActive: true,
        },
        options: {
          token,
          headers: { "Content-Type": "application/json" },
        },
      });
    } catch (err) {
      // network error
      return dispatch(setLocationsError(err));
    }

    if (response && response.ok) {
      toastr.success("Successfully created location");
      return dispatch(fetchLocations());
    }
    return dispatch(setLocationsError(new Error("Response failed")));
  };
}

export function deleteLocation(uuid) {
  return async function (dispatch) {
    const token = getAccessToken();
    let response = null;
    try {
      response = await fetchRequest({
        method: "DELETE",
        path: `${fullAPIURL}/v2/calendar/location/${uuid}`,
        options: {
          token,
        },
      });
    } catch (err) {
      // network error
      return dispatch(setLocationsError(err));
    }

    if (response && response.ok) {
      toastr.success("Successfully deleted location");
      return dispatch(fetchLocations());
    }
    return dispatch(setLocationsError(new Error("Response failed")));
  };
}
